<div class="row border-bottom pb-2 arabic-dir">
  <h5 class="text-primary text-left col-8">
    {{ "BAZZAR.RATE_ORDER" | translate }}
  </h5>
  <i
    class="fa fa-times text-dark text-right text-left-ar col-4 pt-1"
    (click)="onNoClick()"
  >
  </i>
</div>
<div>
  <form action="" class="mt-2">
    <div class="row mx-0 text-center justify-content-center mb-3">
      <ngb-rating
        [max]="5"
        [(rate)]="currentRate"
        [readonly]="false"
      ></ngb-rating>
    </div>
    <div class="form-group">
      <div class="row">
        <textarea
          type="text"
          placeholder="{{ 'BAZZAR.COMMENT' | translate }} ..."
          class="form-control"
          id="comment"
        ></textarea>
      </div>
    </div>
  </form>

  <div class="text-right mt-4 text-left-ar">
    <button class="btn btn-outline-success mx-1" (click)="onNoClick()">
      {{ "BAZZAR.CANCEL" | translate }}
    </button>
    <button class="btn btn-success mx-1">
      {{ "BAZZAR.CONFIRM" | translate }}
    </button>
  </div>
</div>
